import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const DoorIcon = (props: SvgProps) => (
  <Svg
    width={14}
    height={13}
    fill="none"
    {...props}
  >
    <Path
      fill={props.color ?? '#fff'}
      d="M0 12a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1H.5A.5.5 0 0 1 0 12Z"
    />
    <Path
      fill={props.color ?? '#fff'}
      fillRule="evenodd"
      d="M4 .5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-10a1 1 0 0 0-1-1H4Zm5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
      clipRule="evenodd"
    />
  </Svg>
);
export default DoorIcon;
